// Import ES6 Promise
import 'es6-promise/auto'

// Import System requirements
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store'

// Import Helpers for filters
import { domain, count, prettyDate, pluralize } from './filters'

// Import Views - Top level
import AppView from './components/App.vue'

// Firebase
import firebase from 'firebase'

import Chat from 'vue-beautiful-chat'
Vue.use(Chat)


// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)

// Import sweet alert
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

// Import VueFormWizard
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

// importe toggle button
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import Element from 'element-ui'
Vue.use(Element)

sync(store, router)
import 'animate.css/animate.min.css'

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyC5Welq568peSY-wE5vgUhg8Jsns6eq0zE',
  authDomain: 'sev-delivery.firebaseapp.com',
  databaseURL: 'https://sev-delivery.firebaseio.com',
  projectId: 'sev-delivery',
  storageBucket: 'sev-delivery.appspot.com',
  messagingSenderId: '677498504965'
}
firebase.initializeApp(config)

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView),
  VueSweetalert2
})



// WEBPACK FOOTER //
// ./src/main.js